/**
 * Escapa texto para entrar em HTML — texto de nó OU valor de atributo.
 *
 * Módulo único de propósito: esta função vivia copiada em mais de uma dezena
 * de arquivos, cada cópia escapando só `& < > "`. Isso basta para texto de
 * nó e para um atributo escrito com aspas duplas — o que hoje é 100% dos
 * atributos do site —, mas não fecha o valor de um atributo escrito com
 * aspas simples: `'` sem escape encerra o atributo e abre espaço para
 * injetar outro. Um site inteiro em aspas duplas está seguro até o dia em
 * que alguém escrever `attr='${valor}'` sem lembrar da regra — daí a cópia
 * ficar num só lugar, escapando as cinco.
 */
export const esc = (s: string): string =>
  s.replace(/[&<>"']/g, (c) => (
    {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]!
  )
